<template>
  <div>
    <application-creator />
    <webhook-editor />
    <token-generator />
    <event-creator />
    <event-example-viewer />
  </div>
</template>

<script>
export default {
  name: "Dialogs",
  components: {
    ApplicationCreator: () => import(
      './ApplicationCreator'
    ),
    WebhookEditor: () => import(
      './WebhookEditor'
    ),
    EventCreator: () => import(
      './EventForm'
    ),
    EventExampleViewer: () => import(
      './EventExampleViewer'
    )
  }
}
</script>

<style scoped></style>
